<!-- 政策支持新增编辑 -->
<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="dialogTitle"
        width="50%"
        :before-close="handleClose"
    >
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item label="标题" prop="title">
                <el-input v-model="form.title" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="简介" prop="info">
                <el-input v-model="form.info" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="链接" prop="linkUrl">
                <el-input
                    v-model="form.linkUrl"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <!-- <el-form-item label="图片" prop="photoUrl">
                <UploadImage
                    :width="200"
                    :height="150"
                    :maxSize="20"
                    :value="form.photoUrl"
                    ref="uploadImage"
                    @on-change="handleImageChange"
                    @on-remove="handleImageRemove"
                />
            </el-form-item> -->
            <el-form-item label="排序" prop="sort">
                <el-input
                    v-model="form.sort"
                    type="number"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="submitForm">保存</el-button>
        </span>
    </el-dialog>
</template>

<script>
import UploadImage from "@/components/UploadImage.vue";
import { areaPolicySave, areaPolicyUpdate } from "@/api/admin";

export default {
    name: "PolicyForm",
    props: ["areaType"],
    components: {
        UploadImage,
    },
    data() {
        return {
            dialogVisible: false,
            dialogTitle: "新增",
            form: {
                title: "",
                info: "",
                linkUrl: "",
                photoUrl: "",
                sort: undefined,
            },
            rules: {
                title: [
                    { required: true, message: "请输入标题", trigger: "blur" },
                ],
                info: [
                    { required: true, message: "请输入简介", trigger: "blur" },
                ],
                linkUrl: [
                    { required: true, message: "请输入链接", trigger: "blur" },
                ],
                // photoUrl: [
                //     {
                //         required: true,
                //         message: "请上传图片",
                //         trigger: "change",
                //     },
                // ],
                sort: [
                    { required: true, message: "请输入排序", trigger: "blur" },
                ],
            },
        };
    },
    methods: {
        submitForm() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        const params = {
                            ...this.form,
                            areaType: this.areaType,
                        };
                        if (this.form.id) {
                            await areaPolicyUpdate(params);
                        } else {
                            await areaPolicySave(params);
                        }
                        this.$message.success("保存成功");
                        this.$emit("refresh");
                        this.dialogVisible = false;
                    } catch (error) {
                        this.$message.error(error.message || "保存失败");
                    }
                } else {
                    // this.$message.error("请填写完整信息");
                    return false;
                }
            });
        },
        handleImageChange(file) {
            this.form.photoUrl = file;
        },
        handleImageRemove() {
            this.form.photoUrl = "";
        },
        open(row) {
            this.dialogVisible = true;
            if (row) {
                // 编辑
                this.dialogTitle = "编辑政策指南";
                this.form = { ...row };
            } else {
                // 新增
                this.dialogTitle = "新增政策指南";
                this.form = {
                    title: "",
                    info: "",
                    linkUrl: "",
                    photoUrl: "",
                    sort: undefined,
                };
            }
        },
        handleClose() {
            this.dialogVisible = false;
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
    },
};
</script>

<style scoped>
.dialog-footer {
    text-align: right;
}
</style>
